module.exports = __webpack_public_path__ + "static/media/Scania.08523581.jpg";